module.exports = __webpack_public_path__ + "static/media/pig.8dcce12e.svg";